// Function to initialize progress bar
function initializeProgressBar() {
  const scrollContainer = document.querySelector('.product-feature-collection__scroll-container');
  const progressFill = document.querySelector('.product-feature-collection__progress-fill');

  
  if (!scrollContainer || !progressFill) {
    return;
  }
  
  // Function to update progress bar
  function updateProgress() {
    const scrollLeft = scrollContainer.scrollLeft;
    const maxScrollLeft = scrollContainer.scrollWidth - scrollContainer.clientWidth;
    const clientWidth = scrollContainer.clientWidth;
    const scrollWidth = scrollContainer.scrollWidth;

    
    if (maxScrollLeft > 0) {
      // Calculate how much of the content is visible initially
      const visibleRatio = clientWidth / scrollWidth;
      const initialProgress = visibleRatio * 100;
      
      // Calculate scroll progress (0 to 1)
      const scrollProgress = scrollLeft / maxScrollLeft;
      
      // Final progress = initial visible portion + scroll progress of remaining portion
      const finalProgress = initialProgress + (scrollProgress * (100 - initialProgress));
      
      const clampedProgress = Math.min(Math.max(finalProgress, 0), 100);
      progressFill.style.width = `${clampedProgress}%`;
      
      // Debug: Check if the style was actually applied
      const computedStyle = window.getComputedStyle(progressFill);
    } else {
      progressFill.style.width = '9.43%'; // If no scroll needed, show full
    }
  }

  // Update progress bar on scroll
  scrollContainer.addEventListener('scroll', function() {
    updateProgress();
  });

  // Initialize immediately
  updateProgress();
  
  // Initialize progress bar after layout is ready
  requestAnimationFrame(() => {
    updateProgress();
  });
  
  // Also try after a short delay
  setTimeout(() => {
    updateProgress();
  }, 100);

  // Update on window resize (important for responsive layouts)
  window.addEventListener('resize', updateProgress);
}

// Function to initialize navigation buttons
function initializeNavButtons() {
  const leftBtn = document.querySelector('#nav-left-drawer-complementary');
  const rightBtn = document.querySelector('#nav-right-drawer-complementary');
  const scrollContainer = document.getElementById('scroll-container-drawer-complementary');
  
  if (!leftBtn || !rightBtn || !scrollContainer) {
    return false;
  }
  
  // Remove existing listeners to prevent duplicates by cloning
  const newLeftBtn = leftBtn.cloneNode(true);
  const newRightBtn = rightBtn.cloneNode(true);
  leftBtn.parentNode.replaceChild(newLeftBtn, leftBtn);
  rightBtn.parentNode.replaceChild(newRightBtn, rightBtn);
  
  // Add event listeners to new buttons
  newLeftBtn.addEventListener('click', () => {
    scrollContainer.scrollBy({ 
      left: -332,
      behavior: 'smooth' 
    });
  });
  
  newRightBtn.addEventListener('click', () => {
    scrollContainer.scrollBy({ 
      left: 332,
      behavior: 'smooth' 
    });
  });
  
  return true;
}

// Attach to click events for cart drawer
document.addEventListener('click', function(event) {
  const target = event.target.closest('[data-cart-drawer-toggle]');
  if (target) {
    // Wait for the drawer to open, then initialize progress bar and nav buttons
    setTimeout(() => {
      initializeProgressBar();
      initializeNavButtons();
    }, 300);
  }
});

document.addEventListener('click', function(event) {
  const target = event.target.closest('[down-arrow-btn]');
  if (target) {
    // Wait for the drawer to open, then initialize progress bar and nav buttons
    setTimeout(() => {
      initializeProgressBar();
      initializeNavButtons();
    }, 300);
  }
});

document.addEventListener('click', function(event) {
  const target = event.target.closest('[data-add-to-cart]');
  if (target) {
    // Wait for the drawer to open, then initialize progress bar and nav buttons
    setTimeout(() => {
      initializeProgressBar();
      initializeNavButtons();
    }, 1000);
  }
});

// Also try to initialize on DOM ready as fallback
document.addEventListener('DOMContentLoaded', function() {
  setTimeout(() => {
    initializeProgressBar();
    initializeNavButtons();
  }, 1000);
});

// Fallback for dynamic loading (since this is a snippet)
setTimeout(function() {
  const scrollContainer = document.querySelector('.product-feature-collection__scroll-container');
  const progressFill = document.querySelector('.product-feature-collection__progress-fill');
  
  if (scrollContainer && progressFill) {    
    function updateProgressFallback() {
      const scrollLeft = scrollContainer.scrollLeft;
      const maxScrollLeft = scrollContainer.scrollWidth - scrollContainer.clientWidth;
      const clientWidth = scrollContainer.clientWidth;
      const scrollWidth = scrollContainer.scrollWidth;
            
      if (maxScrollLeft > 0) {
        // Calculate how much of the content is visible initially
        const visibleRatio = clientWidth / scrollWidth;
        const initialProgress = visibleRatio * 100;
        
        // Calculate scroll progress (0 to 1)
        const scrollProgress = scrollLeft / maxScrollLeft;
        
        // Final progress = initial visible portion + scroll progress of remaining portion
        const finalProgress = initialProgress + (scrollProgress * (100 - initialProgress));
        
        const clampedProgress = Math.min(Math.max(finalProgress, 0), 100);
        progressFill.style.width = `${clampedProgress}%`;
      } else {
        progressFill.style.width = '100%';
      }
    }
    
    // Add scroll listener
    scrollContainer.addEventListener('scroll', updateProgressFallback);
    
    // Initialize
    updateProgressFallback();
  }
  
  // Initialize nav buttons in fallback
  initializeNavButtons();
}, 5000);

// Additional retry logic specifically for nav buttons to ensure they always work
let navRetryCount = 0;
const maxNavRetries = 10;
const navRetryInterval = setInterval(() => {
  if (initializeNavButtons() || navRetryCount >= maxNavRetries) {
    clearInterval(navRetryInterval);
  }
  navRetryCount++;
}, 500);